module.exports = __webpack_public_path__ + "img/switchOff.1e64f49f.svg";